import { render, staticRenderFns } from "./CoverOption.vue?vue&type=template&id=6c3fafde&scoped=true&"
import script from "./CoverOption.vue?vue&type=script&lang=js&"
export * from "./CoverOption.vue?vue&type=script&lang=js&"
import style0 from "./CoverOption.vue?vue&type=style&index=0&id=6c3fafde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3fafde",
  null
  
)

export default component.exports